/** Default dashboard / auth API host for all applets (override via REACT_APP_LOGIN_API_ENDPOINT). */
export const DEFAULT_LOGIN_API_BASE_URL = 'https://nsight-dashboard-api.darkube.app';

export function getLoginApiBaseUrl(): string {
  const raw = process.env.REACT_APP_LOGIN_API_ENDPOINT || DEFAULT_LOGIN_API_BASE_URL;
  return raw.replace(/\/$/, '');
}
